/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CapabilitiesGroupSubgroupSpec } from './capabilitiesGroupSubgroupSpec';
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface CapabilityOrgDeleteSpec { 
    capabilities?: Array<CapabilitiesGroupSubgroupSpec>;
    /**
     * If set to true, the API deletes all the Capabilities for a given org.
     */
    delete_all?: boolean;
    service_type: ServiceTypeEnum;
}
export namespace CapabilityOrgDeleteSpec {
}


